import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Title from '../Elements/Title';
import Subtitle from '../Elements/Subtitle';
import ArchiveProject from '../Components/ArchiveProject';
import { BREAKPOINT, useDevice } from '../hooks/DeviceContext';
import { ReactComponent as ArrowIcon } from '../assets/header-arrow.svg';

const COLUMN_COUNT = 3;

export default function ArchivePage() {
  const { isMobile } = useDevice();
  const projects = require('../data/archive.json');

  const columnCount = isMobile ? 1 : COLUMN_COUNT;
  const columns = Array.from({ length: columnCount }, () => []);
  projects.forEach((project, index) => {
    columns[index % columnCount].push(project);
  });

  return (
    <Wrapper>
      <Title style={{
        fontFamily: 'Space Grotesk',
        fontWeight: 700,
        fontSize: '1.875rem',
        textTransform: 'uppercase',
      }}>Project archive</Title>
      <Subtitle style={{
        marginTop: '0.875rem',
        marginBottom: '4.375rem',
        marginLeft: '0',
      }}>2022–2026</Subtitle>
      <Grid>
        {columns.map((column, ci) => (
          <Column key={ci}>
            {column.map((project, index) => (
              <ArchiveProject
                key={index}
                title={project.title}
                titleColor={project.titleColor}
                subtitle={project.subtitle}
                description={project.description}
                images={project.images}
                link={project.link}
                linkText={project.linkText}
                linkTextExtra={project.linkTextExtra}
              />
            ))}
          </Column>
        ))}
      </Grid>
      <BackLink>
        <ArrowIcon />
        <Link to="/">Back to selected projects</Link>
      </BackLink>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  padding: 1.875rem var(--padding-side-mob) 2.5rem;

  @media (min-width: ${BREAKPOINT}px) {
    padding: 2.5rem var(--padding-right-desk) 3.75rem var(--padding-left-desk);
  }
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  @media (min-width: ${BREAKPOINT}px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 0 2rem;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  min-width: 0;

  @media (min-width: ${BREAKPOINT}px) {
    flex: 1 1 0;
  }
`;

const BackLink = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  margin: 4rem 0 0;

  svg {
    display: block;
    width: 1.2rem;
    height: 1.188rem;
    rotate: 90deg;

    path {
      fill: var(--blue);
    }
  }

  a {
    font-size: 1.25rem;
    font-family: var(--third-font);
    font-weight: 700;
    line-height: 1.25rem;
    letter-spacing: 0.03em;
    color: var(--blue);
    text-transform: uppercase;
    text-decoration: underline;
  }
`;
